import React, { FC, ReactNode } from "react";
import { Dialog } from "@evergis/ui";

import { useDialogReset } from "../../../hooks/useDialogs";

type DialogProps = PropsOf<typeof Dialog>;

type IModalDialogProps = Omit<DialogProps, "isOpen" | "modal" | "onCloseRequest"> & {
  children?: ReactNode;
};

export const ModalDialog: FC<IModalDialogProps> = ({ children, ...props }) => {
  const closeDialog = useDialogReset();

  return (
    <Dialog {...props} isOpen modal onCloseRequest={closeDialog}>
      {children}
    </Dialog>
  );
};
